import { nudge } from 'store/NudgeContext'

export const tryMe = action => {
    try {
        const attempt = action()

        return attempt
    } catch (e) {
        return e
    }
}

export const getStorage = (key = 'nudge') => {
    const result = localStorage.getItem(key)
    const parsed = JSON.parse(result)
    if (result && parsed) return parsed
    return nudge
}

export const setStorage = (key = 'nudge', storage) => {
    const result = tryMe(() => localStorage.setItem(key, JSON.stringify(storage)))
    if (typeof result === 'string') return result
    return storage
}

export const wipeStorage = (key = 'nudge') => {
    tryMe(() => localStorage.clear(key))
}
export default { getStorage, setStorage, wipeStorage }
